module.exports = __webpack_public_path__ + "img/c08_buildingtechpurebred_Normal_ua.508f1368.webp";